import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../../../__legacy__/models/error.model';
import { IMainApiService } from '../../../../../../../__legacy__/services/api.service';
import { IApiService } from '../../../../../../../__legacy__/services/api.service.base';

export interface ICheckMarkingToolNameUniquenessService {
  checkMarkingToolNameUniqueness(request: CheckMarkingToolNameUniquenessRequest): Promise<boolean>;
}

export namespace ICheckMarkingToolNameUniquenessService {
  export const $: interfaces.ServiceIdentifier<ICheckMarkingToolNameUniquenessService> = Symbol('CHECK_MARKING_TOOL_NAME_UNIQUENESS_SERVICE');
}

export class CheckMarkingToolNameUniquenessRequest {
  projectId: string;
  name: string;
  annotationTypeId?: string;

  constructor(projectId: string, name: string, markingToolId?: string) {
    this.projectId = projectId;
    this.name = name;
    this.annotationTypeId = markingToolId;
  }
}

@injectable()
export class CheckMarkingToolNameUniquenessServiceImpl implements ICheckMarkingToolNameUniquenessService {
  constructor(@inject(IMainApiService.$) readonly apiService: IApiService) {}

  async checkMarkingToolNameUniqueness(request: CheckMarkingToolNameUniquenessRequest): Promise<boolean> {
    const result = await this.apiService.getAsync<boolean>('/AnnotationTypes/CheckAnnotationTypeNameUniqueness', { params: request });

    if (result instanceof ACDLError) {
      throw result;
    }

    return result;
  }
}
